// extracted by mini-css-extract-plugin
export default {"projectsPage":"projectsPage_cQdy","backWrapper":"backWrapper_Xj5r","hoverDim":"hoverDim_cpUw","hover":"hover_SlQ2"};